import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CertificateIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.944 12.697h-.833c-.614 0-1.111-.532-1.111-1.188v-8.32C3 2.532 3.497 2 4.111 2h7.778C12.503 2 13 2.532 13 3.189v8.32c0 .656-.498 1.188-1.111 1.188h-.833M8 12.103c.92 0 1.667-.798 1.667-1.783S8.92 8.537 8 8.537s-1.667.798-1.667 1.783S7.08 12.103 8 12.103m0 0h.012L6.238 14l-1.571-1.68 1.677-1.795M8 12.103 9.774 14l1.571-1.68-1.677-1.795M6.333 4.377h3.334m-4.445 2.08h5.556" /></svg>
  );
}

export default CertificateIcon;
